<style lang="scss">
    @import "./login1.css";
	.qh_phone_class .el-input__inner{
		padding: 0 !important;
	}
	#loginPage{
		.el-select-dropdown__wrap{
			max-height: 17rem !important;
		}
	}
	#loginPage {
			.red_error  {
				border: 1px red solid !important;
			}
		
		.el-autocomplete-suggestion__wrap{
				padding: 10px 0 !important;
		}
	}
	//login
	#loginPage{
		// .cardRight{
			 .logoImg_min {
			    width: 44%;
				    top: 26px;
				    position: relative;
				    left: 27%;
			// }
		}
	}
</style>
<style scoped>

	@media screen and (min-width:2200px){
		.us_1{
			font-size: 0.8rem !important;
		}
		.us_2{
			font-size: 0.8rem !important;
		}
		.us_1_3 > p{
			font-size: 0.65rem !important;
		}
		.us_2_3 > span{
			font-size: 0.65rem !important;
		}
		.btnCode{
			font-size: 0.65rem !important;
		}
		
	}

	.titleImg{
		width: 100%;
		text-align: center;
	}
	.middleImg{
		background: url(../../image/bgImg.png);
		height: 55%;
		background-size: 100% 100%;
		display: flex;
	}
	.contact_us{
		display: flex;
		margin-top: 3%;
	}
	.us_1{
		text-align: left;
		width: 50%;
		border-right: 1px solid #e5e5e5;
		padding-right: 5%;
		font-size: 0.9rem;

	}
	.us_1_1{
		/* width: 50%; */
		float: right;
	}
	.us_1_2{
		display: flex;
		padding: 30px 0;
	}
	.us_1_3{
		width: 5.6rem;
		text-align: center;
	}
	.myFont1 .us_1_3 > p{
		font-size: 0.8rem;
	}
	.myFont1 .us_2_3 > span{
		font-size: 0.8rem;
	}
	.us_1_3 > p{
		color: #1797a7;
		font-size: 0.75rem;
		margin-top: 10px;
	}
	.us_2{
		text-align: left;
		width: 50%;
		padding-left: 5%;
		font-size: 0.9rem;

	}
	.us_2_1{
		width: 50%;
		float: left;
	}
	.us_2_2{
		padding-top: 30px;
	}
	.us_2_3{
		margin-bottom: 10px;
	}
	.us_2_3 > img{
		margin-right: 10px;
		
	}
	.us_2_3 > span{
		color: #1797a7;
		font-size: 0.75rem;
		
	}
	.middle_1{
		height: 70%;
		width: 25%;
		margin: auto;
	}
	.middle_2{
		height: 25%;
		width: 100%;
		background: rgba(255, 255, 255, 0.9);
		display: -webkit-box;
		-webkit-box-pack: center;
		-webkit-box-align: center;
	}
	.middle_2_1{
		font-size: 1.15rem;
		color: #1797a7;
		font-weight: bold;
	}
	.middle_3{
		height: 75%;
		width: 100%;
		background: rgba(255, 255, 255, 0.7);
		padding-top: 1.7rem;
	}
	.myFont1 .btnCode{
		font-size: 0.8rem;
	}
	.btnCode{
		background-color: #1797a7;
		color: #fff;
		font-size: 0.75rem;
		border-radius: 2rem;
		cursor: pointer;
		/* line-height: 48px; */
		padding: 0.1rem 1.2rem;
		position: absolute;
		right: 0;
		min-width: 110px;
	}

</style>

<template>
    <div id="loginPage" :class="[$i18n.locale == 'big5' ? 'myFont1':'myFont2']">
		<div class="titleImg">
			<img style="width:13%;" src="../../image/logoHeader.png" alt="">
		</div>
		<div class="middleImg">
			<div class="middle_1">
				<div class="middle_2"> 
					<div class="middle_2_1">{{$t('login.khtitle')}}</div>
				</div>
				<div class="middle_3">
					<el-form ref="form" :rules="rules" :model="form" label-width="0">
						<el-form-item prop="phone">
							<div class="formList "  :class="handenter&&!form.phone?'red_error':''" >
								<img class="formIcon" src="../../image/sj_1.png">
								<div style="position: relative;">
									<el-select v-model="form.qh" class="qhXz" @change="qhclick">
										<el-option v-for="(item) in qhArr" :key="item.id" :label="'+ '+item.value" :value="item.value" >
											<span style="font-size:.65rem;float: left">{{ item.label }}</span>
											<span style="font-size:.65rem;float: right;" v-if="item.id != 11">+{{ item.value }}</span>
										</el-option>
									</el-select>
									<div style="position: absolute;width: 75%;background: #fff;top: 1px;" v-if="!qhflag">+ {{form.qh}}</div>
									<div style="position: absolute;width: 75%;height:100%;top: 0px;background: #fff;display: flex;align-items: center;justify-content: center;" v-else>
										<div style="font-size: 0.75rem;">+&nbsp;</div>
										<el-input class="qh_phone_class" type="number" v-model="form.qh" oninput="if(value.length>3)value=value.slice(0,3)" style="width: 50%;"></el-input>
									</div>
								</div>
								
								<el-input class="phone" v-model="form.phone" :placeholder="this.$t('login.phoneinput')" type="number" :oninput="form.qh == '852' ? 'if(value.length>8)value=value.slice(0,8)': form.qh == '86'? 'if(value.length>11)value=value.slice(0,11)'  : 'if(value.length>20)value=value.slice(0,20)'"></el-input>
							</div>
						</el-form-item>
						<el-form-item prop="code" >
							<div style="display:flex">
								<div class="formList" style="width:65%;" :class="handenter&&!form.code?'red_error':''" >
									<img class="formIcon" src="../../image/yzm_1.png">
									<el-input class="code" v-model="form.code" :placeholder="this.$t('login.vcodeinput')" type="text" maxlength="6" onkeyup="this.value=this.value.replace(/\D/g,'')" onafterpaste="this.value=this.value.replace(/\D/g,'')" @keyup.enter.native="submitForm()"></el-input>
									
								</div>
								<div class="btnCode"><span style="color:#ffffff" @click="codeFn">{{form.codeIndex}}</span><span style="color:#ffffff" v-if="form.codeIndex != $t('login.yanzhengma')">s{{$t('login.later')}}</span></div>
							</div>
						</el-form-item>
						<el-form-item>
							<button type="button" class="subBtnLogin" @click="submitForm()">{{this.$t('login.khbutton')}}</button>
						</el-form-item>
					</el-form>
				</div>
			</div>
		</div>
		<div class="contact_us">
			<div class="us_1">
				<div class="us_1_1">
					<div style="color: #1797a7;font-weight: 600;padding-left: 25px;">{{$t('login.khzb')}}</div>
					<div class="us_1_2">
						<div class="us_1_3">
							<img src="../../image/sfz_1.png">
							<p>{{$t('login.idcard')}}</p>
						</div>
						<div class="us_1_3">
							<img src="../../image/hz_1.png">
							<p>{{$t('login.pass')}}</p>
						</div>
						<div class="us_1_3">
							<img src="../../image/yhk_1.png">
							<p>{{$t('login.bankcard')}}</p>
						</div>
						
					</div>
				</div>
			</div>
			<div class="us_2">
				<div class="us_2_1">
					<div style="color: #1797a7;font-weight: 600;">{{$t('login.lxwm1')}}</div>
					<div class="us_2_2">
						<div class="us_2_3">
							<img src="../../image/phone_1.png" alt="">
							<span style="width:11rem;display: inline-block;">{{$t('login.ybcx')}}：</span>
							<span style="color:#000">(852) 3971 6919</span>
						</div>
						<div class="us_2_3">
							<img src="../../image/phone_1.png" alt="">
							<span style="width:11rem;display: inline-block;">{{$t('login.jyrx')}}：</span>
							<span style="color:#000">(852) 3971 6928</span>
						</div>
						<div class="us_2_3">
							<img src="../../image/phone_1.png" alt="">
							<span style="width:11rem;display: inline-block;">{{$t('login.mfndzx')}}：</span>
							<span style="color:#000">4001 206 046</span>
						</div>
						<div class="us_2_3">
							<img src="../../image/yx_1.png" alt="">
							<span style="width:11rem;display: inline-block;">{{$t('login.dy')}}：</span>
							<span style="color:#000">cs@qmis.com.hk</span>
						</div>
					</div>
				</div>
			</div>

		</div>
		<!-- :yyFlag="" -->
		<language yuyanFlag="true"></language>
        <div v-if='websta=="pc" && false'>
			<div class="changeLan">
			    <!-- <div @click="changeLanFn('big5')" :class="$i18n.locale == 'big5' ? 'active' : ''">繁體中文</div>
			    <span>|</span>
			    <div @click="changeLanFn('gb')" :class="$i18n.locale == 'gb' ? 'active' : ''">简体中文</div>
			    <span>|</span>
			    <div @click="changeLanFn('eng')" :class="$i18n.locale == 'eng' ? 'active' : ''">English</div> -->
			</div>
			<el-card shadow="always">
			    <div class="loginCard">
			        <div class="cardLeft">
			            <img src="../../image/logo.png" class="logoImg">
			        </div>
			        <div class="cardRight">
			            <div class="dlTitle">
			                {{$t('login.khtitle')}}
			            </div>
			            <div class="mainForm">
			                <el-form ref="form" :rules="rules" :model="form" label-width="0">
			                    <el-form-item prop="phone">
			                        <div class="formList " :class="handenter&&!form.phone?'red_error':''" >
			                            <img class="formIcon" src="../../image/icon_phone.png">
			                            <el-select v-model="form.qh" class="qhXz" >
			                                <el-option v-for="(item) in qhArr" :key="item.id" :label="'+ '+item.value" :value="item.value">
			                                    <span style="font-size:.8rem;float: left">{{ item.label }}</span>
			                                    <span style="font-size:.8rem;float: right;" v-if="item.id != 11">+{{ item.value }}</span>
			                                </el-option>
			                            </el-select>
			                            <el-input class="phone" v-model="form.phone" :placeholder="this.$t('login.phoneinput')" type="number"></el-input>
			                        </div>
			                    </el-form-item>
			                    <el-form-item prop="code">
			                        <div class="formList" :class="handenter&&!form.code?'red_error':''" >
			                            <img class="formIcon" src="../../image/icon_code.png">
			                            <el-input 
										class="code" v-model="form.code" :placeholder="this.$t('login.vcodeinput')" type="text" maxlength="6" onkeyup="this.value=this.value.replace(/\D/g,'')" onafterpaste="this.value=this.value.replace(/\D/g,'')" @keyup.enter.native="submitForm()"></el-input>
			                            <span class="codeBtn" @click="codeFn">{{form.codeIndex}}</span>
			                        </div>
			                    </el-form-item>
			                    <el-form-item>
			                        <button type="button" class="subBtnLogin" @click="submitForm()">{{this.$t('login.khbutton')}}</button>
			                    </el-form-item>
			                </el-form>
			            </div>
			            <div class="bottom">
			                <fieldset class="bottomFieldset"><legend><span class="bottomFgx">{{$t('login.khzb')}}</span></legend></fieldset>
			                <div class="bottomList">
			                    <div class="bottomListIn">
			                        <img src="../../image/iocn_shenfen.png">
			                        <p>{{$t('login.idcard')}}</p>
			                    </div>
			                    <div class="bottomListIn">
			                        <img src="../../image/icon_huzhao.png">
			                        <p>{{$t('login.pass')}}</p>
			                    </div>
			                    <div class="bottomListIn">
			                        <img src="../../image/icon_card.png">
			                        <p>{{$t('login.bankcard')}}</p>
			                    </div>
			                </div>
			            </div>
			        </div>
			    </div>
			</el-card>
		</div>
		<div v-if="false">
			<div class="cardRight" style="height: 100vh;width: 100%;">
					  <!-- <img src="../../image/logo.png" class="logoImg_min"> -->
				<div class="dlTitle">{{$t('login.khtitle')}}</div>
				<div class="mainForm" style="padding: 0 4rem;height: 40vh;">
					<el-form ref="form" :rules="rules" :model="form" label-width="0">
						<el-form-item prop="phone">
							<div class="formList " :class="handenter&&!form.phone?'red_error':''" >
								<img class="formIcon" src="../../image/icon_phone.png">
								<el-select v-model="form.qh" class="qhXz" >
									<el-option v-for="(item) in qhArr" :key="item.id" :label="'+ '+item.value" :value="item.value">
										<span style="font-size:.8rem;float: left">{{ item.label }}</span>
										<span style="font-size:.8rem;float: right;">+{{ item.value }}</span>
									</el-option>
								</el-select>
								<el-input class="phone" v-model="form.phone" :placeholder="this.$t('login.phoneinput')" type="number"></el-input>
							</div>
						</el-form-item>
						<el-form-item prop="code">
							<div class="formList" :class="handenter&&!form.code?'red_error':''" >
								<img class="formIcon" src="../../image/icon_code.png">
								<el-input 
								class="code" v-model="form.code" :placeholder="this.$t('login.vcodeinput')" type="text" maxlength="6" onkeyup="this.value=this.value.replace(/\D/g,'')" onafterpaste="this.value=this.value.replace(/\D/g,'')" @keyup.enter.native="submitForm()"></el-input>
								<span class="codeBtn" @click="codeFn">{{form.codeIndex}}</span>
							</div>
						</el-form-item>
						<el-form-item>
							<button type="button" class="subBtnLogin" @click="submitForm()">{{this.$t('login.khbutton')}}</button>
						</el-form-item>
					</el-form>
				</div>
				<div class="bottom" style="position: static;">
					<fieldset class="bottomFieldset"><legend><span class="bottomFgx">{{$t('login.khzb')}}</span></legend></fieldset>
					<div class="bottomList">
						<div class="bottomListIn">
							<img src="../../image/iocn_shenfen.png">
							<p>{{$t('login.idcard')}}</p>
						</div>
						<div class="bottomListIn">
							<img src="../../image/icon_huzhao.png">
							<p>{{$t('login.pass')}}</p>
						</div>
						<div class="bottomListIn">
							<img src="../../image/icon_card.png">
							<p>{{$t('login.bankcard')}}</p>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>

    import https from '@/plugins/http.js';
    import apiUrl from '@/assets/api.js';

    import App from '@/assets/app.js';
    import language from '../main/mains.vue';

    export default {
		components: {
            language
        },
        data() {
            return {
				qhflag:false,
				websta:this.$store.state.onlinestate,
				handenter:0,
                // 登錄表單值
                form:{
                    qh:'852',
                    phone:'',
                    code:'',
                    codeIndex:this.$t('login.yanzhengma')
                },
                // 手機區號列表
                qhArr:[
                    {id:'1',value: '86',label: this.$t('login.zgdl')}, 
                    {id:'2',value: '852',label: this.$t('login.zgxg')}, 
                    {id:'3',value: '853',label: this.$t('login.zgam')}, 
                    {id:'4',value: '61',label: this.$t('login.adly')}, 
                    {id:'5',value: '1',label: this.$t('login.jnd')},
                    {id:'6',value: '60',label: this.$t('login.mlxy')},
                    {id:'7',value: '1',label: this.$t('login.mg')},
                    {id:'8',value: '65',label: this.$t('login.xjp')},
                    {id:'9',value: '64',label: this.$t('login.xxl')}, 
                    {id:'10',value: '44',label: this.$t('login.yg')},
                    {id:'11',value: '',label: this.$t('login.qt')}
                ],
                // 驗證規則
                rules: {
                    phone: [
                        { required: true, message: ' ', trigger: 'blur' },// this.$t('login.phoneinputp')
                    ],
                    code: [
                        { required: true, message: ' ', trigger: 'blur' },//this.$t('login.vscodep')
                    ],
                }
            };
        },
        beforeCreate(){
            // let aaa = '';
            let _this = this;
            if(_this.$route.query.lang){
                _this.$i18n.locale = _this.$route.query.lang;
                localStorage.setItem("lang", _this.$route.query.lang);
            }else if(localStorage.getItem('lang') && (localStorage.getItem('lang') == 'big5' || localStorage.getItem('lang') == 'gb' || localStorage.getItem('lang') == 'eng')){
                _this.$i18n.locale = localStorage.getItem('lang');
            }else{
                _this.$i18n.locale = 'big5';
                localStorage.setItem("lang",'big5');
            }
        },
		methods: {
			qhclick(val){
				if(!val){
					this.qhflag = true
				}else{
					this.qhflag = false
				}
				console.log(this.qhflag);
				
			},
            // 切換語言
            changeLanFn(lan){
                let _this = this;
                _this.$i18n.locale = lan;
                localStorage.setItem("lang", lan);
                _this.qhArr = [
                    {id:'1',value: '86',label: _this.$t('login.zgdl')}, 
                    {id:'2',value: '852',label: _this.$t('login.zgxg')}, 
                    {id:'3',value: '853',label: _this.$t('login.zgam')}, 
                    {id:'4',value: '61',label: _this.$t('login.adly')}, 
                    {id:'5',value: '1',label: _this.$t('login.jnd')},
                    {id:'6',value: '60',label: _this.$t('login.mlxy')},
                    {id:'7',value: '1',label: _this.$t('login.mg')},
                    {id:'8',value: '65',label: _this.$t('login.xjp')},
                    {id:'9',value: '64',label: _this.$t('login.xxl')}, 
                    {id:'10',value: '44',label: _this.$t('login.yg')},
                    {id:'11',value: '',label: this.$t('login.qt')}
                ];
                _this.rules.phone[0].message = _this.$t('allpage.qtxbtx');
                _this.rules.code[0].message = _this.$t('allpage.qtxbtx');
                _this.$refs['form'].resetFields();
            },
            submitForm(){
				console.log(this.websta);
				this.handenter++;
                let _this = this;
                _this.$refs['form'].validate((valid) => {
                    if (valid) {
                        https.fetchLoginPost(apiUrl.register,{
                            nationcode: _this.form.qh,
                            phonenum: _this.form.phone,
                            language: _this.$i18n.locale,
                            loginarea: 4,
                            captcha: _this.form.code
                        }).then((data) => {
                            if(Object.is(data.qmiscode,1000)){
                                if(data.moveto == 9){
                                    _this.$router.push({name: 'finish',params:{progress:data.progress}});
                                    return;
                                }else{
                                    console.log(data);
                                    data.phone = _this.form.phone;
                                    _this.$store.commit('adminlogin',data);
                                    App.oTool.successT(_this.$t('login.success'),2000,()=>{
                                        _this.$router.push({path: '/main/checkPdf'});
                                    })
                                }
                            }else{
                                App.oTool.warningT(data.qmismsg)
                            }
                        }).catch(err => {
                            console.log(err);
                        });
                    } else {
                        return false;
                    }
                });
            },
            codeFn(){
                let _this = this;
				console.log(_this.form,_this.$t('login.yanzhengma'))
                if(!Object.is(_this.$t('login.yanzhengma'),_this.form.codeIndex)){
                    return
                }
                _this.$refs['form'].validateField('phone',(valid) => {
                    if (!valid) {
                        https.fetchLoginPost(apiUrl.getVerificationCode,{
                            nationcode: _this.form.qh,
                            phonenum: _this.form.phone,
                            language: _this.$i18n.locale
                        }).then((data) => {
                            if(Object.is(data.qmiscode,1000)){
                                App.oTool.successT(data.qmismsg,2000)
                                _this.form.codeIndex = 60;
                                let timer = setInterval(() => {
                                    if(_this.form.codeIndex <= 1){
                                        _this.form.codeIndex = _this.$t('login.yanzhengma');
                                        clearInterval(timer);
                                        return
                                    }
                                    _this.form.codeIndex --;
                                },1000)
                            }else{
                                App.oTool.warningT(data.qmismsg)
                            }
                        }).catch(err => {
                            console.log(err);
                        });
                    } else {
                        return false;
                    }
                });
            }
        },
    };
</script>
